import httpService from "../../components/service";

export const displays = {
    namespaced: true,
    state: {
        items: {},
        displayType: {},
        systemTypesList: []
    },

    getters: {
        getDisplays: state => {
            return state.items;
        },
        getDisplayType: state => {
            return state.displayType;
        },
        getSystemTypesList: state => {
            return state.systemTypesList;
        }
    },
    mutations: {
        POPULATE_ITEMS(state, data) {
            state.items = data;
        },
        ENRICH_DISPLAY(state, data) {
            state.displayType = data;
        }
    },
    actions: {
        populate: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService.get("/displayers", JSON.stringify({})).then(response => {
                    let items = response.data;
                    context.commit("POPULATE_ITEMS", items);
                    resolve();
                });
            });
        },
        getDisplayType: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService.get("/displayers/types").then(response => {
                    context.commit("ENRICH_DISPLAY", response.data);
                    resolve(response.data);
                });
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/items/display.js